<template>
  <div v-if="property && variants.v1 === variant" class="tw-pb-64 tw-pt-36">
    <library-container>
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-justify-between">
          <library-properties-back-to-all-properties-navbar />
        </div>
        <div class="mt-5 tw-flex tw-grid tw-grid-cols-12 tw-items-center">
          <div
            class="tw-col-span-12 tw-mb-4 tw-flex tw-flex-col tw-justify-center tw-gap-y-4 lg:tw-mb-0 lg:tw-gap-y-0 xl:tw-col-span-7"
          >
            <library-title tag="h1" class="tw-text-[26px]" :text="property.advert_heading"></library-title>
            <library-text class="tw-mt-2 tw-capitalize" :text="property.display_address"></library-text>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-justify-between tw-gap-y-4 md:tw-col-span-5 md:tw-flex-row md:tw-items-center md:tw-gap-x-6 md:tw-gap-y-0"
          >
            <div v-if="property.price">
              <div class="tw-text-lg tw-capitalize">
                {{ property.price.type.name }}
              </div>
              <div class="tw-text-xl tw-font-bold">
                {{ property.price.price }}
              </div>
            </div>
            <div v-if="!property.is_locked" class="tw-flex tw-gap-x-4">
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.6673 13.8333V12.8333M3.33398 13.8333V12.8333"
                      stroke="#222222"
                      stroke-width="0.8"
                      stroke-linecap="round"
                    />
                    <path
                      d="M14.0007 8.49996C14.0007 5.98596 14.0007 4.72863 13.2193 3.94796C12.4387 3.16663 11.1813 3.16663 8.66732 3.16663H7.33398C4.81998 3.16663 3.56265 3.16663 2.78198 3.94796C2.00065 4.72863 2.00065 5.98596 2.00065 8.49996M1.33398 10.5C1.33398 9.87863 1.33398 9.56796 1.43532 9.32329C1.50233 9.16141 1.60058 9.01433 1.72447 8.89044C1.84835 8.76656 1.99544 8.6683 2.15732 8.60129C2.40198 8.49996 2.71265 8.49996 3.33398 8.49996H12.6673C13.2887 8.49996 13.5993 8.49996 13.844 8.60129C14.0059 8.6683 14.153 8.76656 14.2768 8.89044C14.4007 9.01433 14.499 9.16141 14.566 9.32329C14.6673 9.56796 14.6673 9.87863 14.6673 10.5C14.6673 11.1213 14.6673 11.432 14.566 11.6766C14.499 11.8385 14.4007 11.9856 14.2768 12.1095C14.153 12.2334 14.0059 12.3316 13.844 12.3986C13.5993 12.5 13.2887 12.5 12.6673 12.5H3.33398C2.71265 12.5 2.40198 12.5 2.15732 12.3986C1.99544 12.3316 1.84835 12.2334 1.72447 12.1095C1.60058 11.9856 1.50233 11.8385 1.43532 11.6766C1.33398 11.432 1.33398 11.1213 1.33398 10.5Z"
                      stroke="#222222"
                      stroke-width="0.8"
                    />
                    <path
                      d="M12.3346 8.49992V7.49992C12.3346 6.24259 12.3346 5.61459 11.944 5.22392C11.5533 4.83325 10.9253 4.83325 9.66797 4.83325H6.33464C5.0773 4.83325 4.4493 4.83325 4.05864 5.22392C3.66797 5.61459 3.66797 6.24259 3.66797 7.49992V8.49992M8.0013 5.16659V8.49992"
                      stroke="#222222"
                      stroke-width="0.8"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">BD</div>
                <div class="tw-text-xl" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.bedroom }}
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 9.16667V11.1667C14 11.8739 13.719 12.5522 13.219 13.0523C12.7189 13.5524 12.0406 13.8333 11.3333 13.8333H4.66667C3.95942 13.8333 3.28115 13.5524 2.78105 13.0523C2.28095 12.5522 2 11.8739 2 11.1667V9.56667C2 9.46058 2.04214 9.35884 2.11716 9.28382C2.19217 9.20881 2.29391 9.16667 2.4 9.16667H14ZM14 9.16667V5.16667C14 4.45942 13.719 3.78115 13.219 3.28105C12.7189 2.78095 12.0406 2.5 11.3333 2.5H8M10.6667 13.8333L11.3333 15.1667M5.33333 13.8333L4.66667 15.1667"
                      stroke="black"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.2663 5.83333H5.73294C5.51228 5.83333 5.33561 5.65467 5.35961 5.43467C5.45694 4.55 5.90828 2.5 7.99961 2.5C10.0909 2.5 10.5423 4.55 10.6396 5.43467C10.6636 5.65467 10.4869 5.83333 10.2663 5.83333Z"
                      stroke="black"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">BA</div>
                <div class="tw-text-xl" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.bathroom }}
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.93732 3.33337H10.064C10.6227 3.33337 10.9787 3.33337 11.2853 3.39404C11.8996 3.51623 12.4638 3.81782 12.9067 4.26068C13.3495 4.70354 13.6511 5.26778 13.7733 5.88204C13.82 6.11537 13.8307 6.37737 13.8333 6.73537C14.2174 6.84422 14.5556 7.07545 14.7963 7.39394C15.0371 7.71243 15.1673 8.10079 15.1673 8.50004V10.1294C15.1673 11.1494 14.6353 12.0454 13.834 12.554V13.1667C13.834 13.2993 13.7813 13.4265 13.6875 13.5203C13.5938 13.614 13.4666 13.6667 13.334 13.6667C13.2014 13.6667 13.0742 13.614 12.9804 13.5203C12.8867 13.4265 12.834 13.2993 12.834 13.1667V12.95C12.66 12.9834 12.4807 13 12.2967 13H3.70465C3.52065 13 3.34132 12.9827 3.16732 12.95V13.1667C3.16732 13.2993 3.11464 13.4265 3.02087 13.5203C2.9271 13.614 2.79993 13.6667 2.66732 13.6667C2.53471 13.6667 2.40753 13.614 2.31376 13.5203C2.22 13.4265 2.16732 13.2993 2.16732 13.1667V12.554C1.7587 12.2952 1.42218 11.9372 1.18906 11.5134C0.955936 11.0896 0.833791 10.6137 0.833985 10.13V8.50004C0.833985 7.66004 1.39798 6.95337 2.16798 6.73537C2.17065 6.37737 2.18132 6.11537 2.22798 5.88204C2.35017 5.26778 2.65177 4.70354 3.09463 4.26068C3.53749 3.81782 4.10172 3.51623 4.71598 3.39404C5.02265 3.33337 5.37865 3.33337 5.93732 3.33337ZM3.16865 6.73604C3.5523 6.84522 3.88989 7.0765 4.13026 7.39483C4.37063 7.71315 4.50066 8.10116 4.50065 8.50004V9.30004C4.50065 9.31871 4.51532 9.33337 4.53398 9.33337H11.4673C11.4762 9.33337 11.4846 9.32986 11.4909 9.32361C11.4971 9.31736 11.5007 9.30888 11.5007 9.30004V8.50004C11.5007 7.66137 12.064 6.95404 12.8327 6.73604C12.83 6.39604 12.8213 6.22271 12.7927 6.07737C12.7091 5.65698 12.5027 5.27081 12.1996 4.96773C11.8965 4.66465 11.5104 4.45827 11.09 4.37471C10.8927 4.33604 10.644 4.33337 10.0007 4.33337H6.00065C5.35732 4.33337 5.10865 4.33604 4.91132 4.37471C4.49092 4.45827 4.10476 4.66465 3.80168 4.96773C3.49859 5.27081 3.29222 5.65698 3.20865 6.07737C3.17998 6.22271 3.17132 6.39671 3.16865 6.73604ZM2.66732 7.66671C2.20732 7.66671 1.83398 8.04004 1.83398 8.50004V10.1294C1.83398 10.6255 2.03107 11.1013 2.38189 11.4521C2.73271 11.803 3.20852 12 3.70465 12H12.2967C12.7928 12 13.2686 11.803 13.6194 11.4521C13.9702 11.1013 14.1673 10.6255 14.1673 10.1294V8.50004C14.1673 8.27903 14.0795 8.06707 13.9232 7.91079C13.767 7.7545 13.555 7.66671 13.334 7.66671C13.113 7.66671 12.901 7.7545 12.7447 7.91079C12.5884 8.06707 12.5007 8.27903 12.5007 8.50004V9.30004C12.5007 9.5741 12.3918 9.83693 12.198 10.0307C12.0042 10.2245 11.7414 10.3334 11.4673 10.3334H4.53398C4.25993 10.3334 3.9971 10.2245 3.80331 10.0307C3.60952 9.83693 3.50065 9.5741 3.50065 9.30004V8.50004C3.50065 8.04004 3.12732 7.66671 2.66732 7.66671Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">RE</div>
                <div class="tw-text-xl" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.reception }}
                </div>
              </div>
            </div>
            <div
              class="share-button tw-flex tw-w-2/5 tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded tw-px-7 tw-py-5 md:tw-w-3/5 lg:tw-w-auto"
              @click="onShared()"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 18.3333C14.3056 18.3333 13.7153 18.0903 13.2292 17.6042C12.7431 17.118 12.5 16.5278 12.5 15.8333C12.5 15.7361 12.5069 15.6353 12.5208 15.5308C12.5347 15.4264 12.5556 15.3328 12.5833 15.25L6.70833 11.8333C6.47222 12.0417 6.20833 12.205 5.91667 12.3233C5.625 12.4417 5.31944 12.5005 5 12.5C4.30556 12.5 3.71528 12.2569 3.22917 11.7708C2.74306 11.2847 2.5 10.6944 2.5 9.99999C2.5 9.30555 2.74306 8.71527 3.22917 8.22916C3.71528 7.74305 4.30556 7.49999 5 7.49999C5.31944 7.49999 5.625 7.55916 5.91667 7.67749C6.20833 7.79582 6.47222 7.95888 6.70833 8.16666L12.5833 4.74999C12.5556 4.66666 12.5347 4.57305 12.5208 4.46916C12.5069 4.36527 12.5 4.26443 12.5 4.16666C12.5 3.47221 12.7431 2.88193 13.2292 2.39582C13.7153 1.90971 14.3056 1.66666 15 1.66666C15.6944 1.66666 16.2847 1.90971 16.7708 2.39582C17.2569 2.88193 17.5 3.47221 17.5 4.16666C17.5 4.8611 17.2569 5.45138 16.7708 5.93749C16.2847 6.4236 15.6944 6.66666 15 6.66666C14.6806 6.66666 14.375 6.60777 14.0833 6.48999C13.7917 6.37221 13.5278 6.20888 13.2917 5.99999L7.41667 9.41666C7.44444 9.49999 7.46528 9.59388 7.47917 9.69832C7.49306 9.80277 7.5 9.90332 7.5 9.99999C7.5 10.0972 7.49306 10.198 7.47917 10.3025C7.46528 10.4069 7.44444 10.5005 7.41667 10.5833L13.2917 14C13.5278 13.7917 13.7917 13.6286 14.0833 13.5108C14.375 13.393 14.6806 13.3339 15 13.3333C15.6944 13.3333 16.2847 13.5764 16.7708 14.0625C17.2569 14.5486 17.5 15.1389 17.5 15.8333C17.5 16.5278 17.2569 17.118 16.7708 17.6042C16.2847 18.0903 15.6944 18.3333 15 18.3333Z"
                  fill="#222222"
                />
              </svg>
              <span class="tw-font-bold tw-uppercase"> Share </span>
            </div>
          </div>
        </div>
      </div>
    </library-container>
    <!-- GALLERY: START -->
    <div class="tw-mt-16 tw-grid tw-grid-cols-12 tw-gap-x-1">
      <div class="tw-relative tw-col-span-12 tw-w-full lg:tw-col-span-6" @click="onClickedImage(null)">
        <library-image
          :src="primaryFivePhotos[0].background"
          image-class="tw-rounded"
          @click="onClickedImage(primaryFivePhotos[0])"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        ></library-image>
        <div v-if="isMobileDevice" class="photo-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-width="2" d="m9 6l6 6l-6 6" />
          </svg>
        </div>
        <div v-if="isMobileDevice" class="photo-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-width="2" d="m15 6l-6 6l6 6" />
          </svg>
        </div>
        <div v-if="property.medias && property.medias.length" class="nc-first-image-overlay-item">
          <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
            1/{{ property.medias.length }}
          </div>
        </div>
      </div>
      <div v-if="!isMobileDevice" class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-x-1 md:tw-col-span-6">
        <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-1 md:tw-flex-col">
          <library-image
            :src="primaryFivePhotos[1].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[1])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>

          <library-image
            v-if="primaryFivePhotos[2]"
            :src="primaryFivePhotos[2].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[2])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
        <div class="tw-relative tw-col-span-6 tw-flex tw-flex-row tw-gap-y-1 md:tw-flex-col">
          <library-image
            v-if="primaryFivePhotos[3]"
            :src="primaryFivePhotos[3].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[3])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
          <library-image
            v-if="primaryFivePhotos[4]"
            :src="primaryFivePhotos[4].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[4])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
          <div
            v-if="primaryFivePhotos[4] && primaryFivePhotos[4].property_profile_media_id"
            class="nc-all-photos-button tw-cursor-pointer tw-uppercase"
            @click="onClickedImage(primaryFivePhotos[4])"
          >
            <library-text text="VIEW ALL PHOTOS" class="tw-text-xs tw-font-bold"></library-text>
          </div>
        </div>
      </div>
      <div v-if="isMobileDevice" class="tw-col-span-12 tw-mt-1 tw-grid tw-grid-cols-12 tw-gap-x-1">
        <div class="tw-col-span-6">
          <library-image
            v-if="primaryFivePhotos[1]"
            :src="primaryFivePhotos[1].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[1])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
        <div class="tw-col-span-6">
          <library-image
            v-if="primaryFivePhotos[2]"
            :src="primaryFivePhotos[2].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[2])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
      </div>
    </div>
    <!-- GALLERY: END -->
    <library-container v-if="!property.is_locked" class="tw-mt-20">
      <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
        <div class="tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-8">
          <!-- Property Video, Send Lead: START -->
          <property-detail-actions
            v-if="isMobileDevice"
            :property="property"
            :component="component"
            class="tw-col-span-12"
            @on-send-lead="onSendLead()"
          />
          <!-- Property Video, Send Lead: END -->

          <!-- FEATURES: START -->
          <div v-if="!property.is_locked" class="tw-flex tw-flex-col">
            <library-title text="Features" tag="h3"></library-title>
            <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-x-3" ref="featuresGrid">
              <div
                v-for="(feature, index) in property.features"
                :key="`property-feature-${index}`"
                class="tw-col-span-12 tw-flex md:tw-col-span-6"
                :class="featuresBoxStyle === 1 ? 'tw-items-center' : ''"
                :style="[featuresBoxStyle === 2 ? `border-bottom: 1px solid var(--default-border-color)` : '']"
                style="padding-top: 15px; padding-bottom: 15px; height: auto"
              >
                <span v-if="featuresBoxStyle === 1" class="tw-pr-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                      fill="#BFA86C"
                    />
                  </svg>
                </span>
                <library-text class="feature-text tw-text-sm tw-font-semibold tw-uppercase" :text="feature">
                </library-text>
              </div>
            </div>
          </div>
          <!-- FEATURES: END -->
          <div v-if="!property.is_locked">
            <library-title text="Property Information" tag="h3"></library-title>
            <ul class="nav nav-tabs pxp-nav-tabs tw-mt-3">
              <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
                <div
                  :class="activeTab === tab.name ? 'active' : ''"
                  class="nav-link tw-cursor-pointer"
                  data-toggle="tab"
                  @click="activeTab = tab.name"
                >
                  {{ tab.title }}
                </div>
              </li>
            </ul>
            <div class="tab-content tw-mt-6">
              <div v-show="activeTab === 'description'" id="description" role="tabpanel">
                <div>
                  <div v-if="property.description">
                    <library-text class="tw-text-sm" :html="property.description"></library-text>
                  </div>
                </div>
              </div>
              <div v-show="activeTab === 'information'" id="information" role="tabpanel">
                <library-properties-property-criteria-list :property="property" :main-list-title="null">
                  <template #list-item="{ criteria }">
                    <library-title tag="h5" :text="criteria.title"></library-title>
                    <library-text class="tw-capitalize" :text="criteria.value"></library-text>
                  </template>
                </library-properties-property-criteria-list>
              </div>
              <div v-show="activeTab === 'video'" id="video" role="tabpanel">
                <div v-if="property?.featured_video">
                  <theme2-components-video-popup
                    :component="component"
                    :video-source="property.featured_video.mediaLink"
                  />
                </div>
              </div>
              <div v-show="activeTab === 'floor_plan'" id="floor_plan" role="tabpanel">
                <floor-plan :data="property.floor_plans" :component="component" />
              </div>
              <div v-show="activeTab === 'map'" id="map" role="tabpanel">
                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColor"
                />
              </div>
              <div v-show="activeTab === 'epc'" id="epc" role="tabpanel">
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>

          <library-tools-stamp-duty-calculator
            v-if="isMortgageCalculatorVisible && !property.is_locked"
            :default-price="property.price.numberPrice"
          />
          <library-tools-mortgage-calculator
            v-if="isStampDutyCalculatorVisible && !property.is_locked"
            :default-price="property.price.numberPrice"
          />
        </div>
        <!-- Property Video, Send Lead: START -->
        <div class="tw-col-span-12 lg:tw-col-span-4">
          <property-detail-actions
            v-if="!isMobileDevice"
            :property="property"
            :component="component"
            @on-send-lead="onSendLead()"
          />
          <div v-if="sidebarComponents && sidebarComponents.length" class="tw-mt-4">
            <available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
        <!-- Property Video, Send Lead: END -->
      </div>
    </library-container>

    <library-container v-else-if="property.is_locked">
      <div class="tw-mt-10">
        <library-login />
      </div>
    </library-container>

    <full-screen-gallery
      v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias && !property.is_locked"
      v-model:active-media-index="activeMediaIndex"
      :component="component"
      :active-media="activeMedia"
      :count-of-medias="property.medias.length"
      @close="closeLightbox()"
    />

    <popup v-if="!property.is_locked" :config="sendLeadPopupConfig" custom-width="800px">
      <template #content>
        <send-lead
          v-if="sendLeadPopupConfig.isActive"
          :property="property"
          @on-success="onSuccess"
          @close="sendLeadPopupConfig.isActive = false"
        />
      </template>
    </popup>
    <popup v-if="!property.is_locked" :config="successModalConfig" @close="onSuccessModalClosed()">
      <template #content>
        <success :text="successPopupText" />
      </template>
    </popup>
  </div>

  <div v-if="property && variants.v2 === variant" class="tw-pb-36 tw-pt-40 md:tw-pt-48 lg:tw-pt-60">
    <library-container>
      <div class="tw-flex tw-flex-col">
        <div class="tw-flex tw-justify-between">
          
          <nuxt-link
        :to="property && property.is_rent ? '/lettings/property-to-rent' : '/properties'"
        :external="true"
       
        class="n-link  tw-flex tw-items-center tw-gap-3 tw-self-start !tw-p-0 tw-text-[var(--c-primary)] "
      >
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.46967 11.9697C0.176777 12.2626 0.176777 12.7374 0.46967 13.0303L5.24264 17.8033C5.53553 18.0962 6.01041 18.0962 6.3033 17.8033C6.59619 17.5104 6.59619 17.0355 6.3033 16.7426L2.06066 12.5L6.3033 8.25736C6.59619 7.96447 6.59619 7.48959 6.3033 7.1967C6.01041 6.90381 5.53553 6.90381 5.24264 7.1967L0.46967 11.9697ZM21 12.5V11.75L1 11.75V12.5V13.25L21 13.25V12.5Z"
            fill="var(--c-primary)"
          />
        </svg>

       <h6>Back to All Properties</h6> 
      </nuxt-link>
        </div>
        <div class="mt-5 tw-flex tw-grid tw-grid-cols-12 tw-items-center">
          <div
            class="tw-col-span-12 tw-mb-4 tw-flex tw-flex-col tw-justify-center tw-gap-y-4 lg:tw-mb-0 lg:tw-gap-y-0 xl:tw-col-span-7"
          >
            <h3>{{ property.advert_heading }}</h3>
            <p class="tw-mb-3 tw-mt-5 tw-flex tw-items-center tw-gap-3">
              <span
                ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 9.5C7.50555 9.5 7.0222 9.35338 6.61108 9.07868C6.19995 8.80397 5.87952 8.41353 5.6903 7.95671C5.50108 7.49989 5.45157 6.99723 5.54804 6.51228C5.6445 6.02732 5.8826 5.58187 6.23223 5.23223C6.58187 4.8826 7.02732 4.6445 7.51228 4.54804C7.99723 4.45157 8.4999 4.50108 8.95671 4.6903C9.41353 4.87952 9.80397 5.19995 10.0787 5.61108C10.3534 6.0222 10.5 6.50555 10.5 7C10.4992 7.6628 10.2356 8.29822 9.76689 8.76689C9.29822 9.23556 8.6628 9.49921 8 9.5ZM8 5.5C7.70333 5.5 7.41332 5.58797 7.16665 5.7528C6.91997 5.91762 6.72771 6.15189 6.61418 6.42598C6.50065 6.70007 6.47095 7.00167 6.52882 7.29264C6.5867 7.58361 6.72956 7.85088 6.93934 8.06066C7.14912 8.27044 7.41639 8.4133 7.70737 8.47118C7.99834 8.52906 8.29994 8.49935 8.57403 8.38582C8.84812 8.27229 9.08238 8.08003 9.24721 7.83336C9.41203 7.58668 9.5 7.29667 9.5 7C9.4996 6.6023 9.34144 6.221 9.06022 5.93978C8.779 5.65856 8.3977 5.5004 8 5.5Z"
                    fill="#90C73D"
                  />
                  <path
                    d="M8.00001 15.5L3.78201 10.5255C3.7234 10.4508 3.66539 10.3756 3.60801 10.3C2.8875 9.35089 2.49826 8.19161 2.50001 7C2.50001 5.54131 3.07947 4.14236 4.11092 3.11091C5.14237 2.07946 6.54132 1.5 8.00001 1.5C9.4587 1.5 10.8576 2.07946 11.8891 3.11091C12.9205 4.14236 13.5 5.54131 13.5 7C13.5018 8.19107 13.1127 9.34982 12.3925 10.2985L12.392 10.3C12.392 10.3 12.242 10.497 12.2195 10.5235L8.00001 15.5ZM4.40651 9.6975C4.40651 9.6975 4.52301 9.8515 4.54951 9.8845L8.00001 13.954L11.455 9.879C11.477 9.8515 11.594 9.6965 11.5945 9.696C12.1831 8.92056 12.5012 7.97352 12.5 7C12.5 5.80653 12.0259 4.66193 11.182 3.81802C10.3381 2.97411 9.19348 2.5 8.00001 2.5C6.80653 2.5 5.66194 2.97411 4.81803 3.81802C3.97411 4.66193 3.50001 5.80653 3.50001 7C3.49896 7.97412 3.81739 8.92171 4.40651 9.6975Z"
                    fill="#90C73D"
                  />
                </svg>
              </span>
              {{ property.display_address }}
            </p>
          </div>
          <div
            class="tw-col-span-12 tw-flex tw-flex-col tw-items-start tw-justify-between tw-gap-y-8 md:tw-col-span-5 md:tw-flex-row md:tw-items-center md:tw-gap-x-6 md:tw-gap-y-0"
          >
            <div v-if="property.price">
              <p class="tw-capitalize">
                {{ property.price.type.name }}
              </p>
              <h5 class="">
                {{ property.price.price }}
              </h5>
            </div>
            <div v-if="!property.is_locked" class="tw-flex tw-gap-x-4">
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.6673 13.8333V12.8333M3.33398 13.8333V12.8333"
                      stroke="var(--c-secondary)"
                      stroke-width="0.8"
                      stroke-linecap="round"
                    />
                    <path
                      d="M14.0007 8.49996C14.0007 5.98596 14.0007 4.72863 13.2193 3.94796C12.4387 3.16663 11.1813 3.16663 8.66732 3.16663H7.33398C4.81998 3.16663 3.56265 3.16663 2.78198 3.94796C2.00065 4.72863 2.00065 5.98596 2.00065 8.49996M1.33398 10.5C1.33398 9.87863 1.33398 9.56796 1.43532 9.32329C1.50233 9.16141 1.60058 9.01433 1.72447 8.89044C1.84835 8.76656 1.99544 8.6683 2.15732 8.60129C2.40198 8.49996 2.71265 8.49996 3.33398 8.49996H12.6673C13.2887 8.49996 13.5993 8.49996 13.844 8.60129C14.0059 8.6683 14.153 8.76656 14.2768 8.89044C14.4007 9.01433 14.499 9.16141 14.566 9.32329C14.6673 9.56796 14.6673 9.87863 14.6673 10.5C14.6673 11.1213 14.6673 11.432 14.566 11.6766C14.499 11.8385 14.4007 11.9856 14.2768 12.1095C14.153 12.2334 14.0059 12.3316 13.844 12.3986C13.5993 12.5 13.2887 12.5 12.6673 12.5H3.33398C2.71265 12.5 2.40198 12.5 2.15732 12.3986C1.99544 12.3316 1.84835 12.2334 1.72447 12.1095C1.60058 11.9856 1.50233 11.8385 1.43532 11.6766C1.33398 11.432 1.33398 11.1213 1.33398 10.5Z"
                      stroke="var(--c-secondary)"
                      stroke-width="0.8"
                    />
                    <path
                      d="M12.3346 8.49992V7.49992C12.3346 6.24259 12.3346 5.61459 11.944 5.22392C11.5533 4.83325 10.9253 4.83325 9.66797 4.83325H6.33464C5.0773 4.83325 4.4493 4.83325 4.05864 5.22392C3.66797 5.61459 3.66797 6.24259 3.66797 7.49992V8.49992M8.0013 5.16659V8.49992"
                      stroke="var(--c-secondary)"
                      stroke-width="0.8"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">BD</div>
                <h4 style="font-weight: 300 !important" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.bedroom }}
                </h4>
              </div>
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M14 9.16667V11.1667C14 11.8739 13.719 12.5522 13.219 13.0523C12.7189 13.5524 12.0406 13.8333 11.3333 13.8333H4.66667C3.95942 13.8333 3.28115 13.5524 2.78105 13.0523C2.28095 12.5522 2 11.8739 2 11.1667V9.56667C2 9.46058 2.04214 9.35884 2.11716 9.28382C2.19217 9.20881 2.29391 9.16667 2.4 9.16667H14ZM14 9.16667V5.16667C14 4.45942 13.719 3.78115 13.219 3.28105C12.7189 2.78095 12.0406 2.5 11.3333 2.5H8M10.6667 13.8333L11.3333 15.1667M5.33333 13.8333L4.66667 15.1667"
                      stroke="var(--c-secondary)"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10.2663 5.83333H5.73294C5.51228 5.83333 5.33561 5.65467 5.35961 5.43467C5.45694 4.55 5.90828 2.5 7.99961 2.5C10.0909 2.5 10.5423 4.55 10.6396 5.43467C10.6636 5.65467 10.4869 5.83333 10.2663 5.83333Z"
                      stroke="var(--c-secondary)"
                      stroke-width="0.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">BA</div>
                <h4 style="font-weight: 300 !important" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.bathroom }}
                </h4>
              </div>
              <div class="tw-flex tw-items-center tw-gap-x-2">
                <div v-if="!isLetterPropertyCriteria" class="tw-order-1">
                  <svg width="26" height="27" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.93732 3.33337H10.064C10.6227 3.33337 10.9787 3.33337 11.2853 3.39404C11.8996 3.51623 12.4638 3.81782 12.9067 4.26068C13.3495 4.70354 13.6511 5.26778 13.7733 5.88204C13.82 6.11537 13.8307 6.37737 13.8333 6.73537C14.2174 6.84422 14.5556 7.07545 14.7963 7.39394C15.0371 7.71243 15.1673 8.10079 15.1673 8.50004V10.1294C15.1673 11.1494 14.6353 12.0454 13.834 12.554V13.1667C13.834 13.2993 13.7813 13.4265 13.6875 13.5203C13.5938 13.614 13.4666 13.6667 13.334 13.6667C13.2014 13.6667 13.0742 13.614 12.9804 13.5203C12.8867 13.4265 12.834 13.2993 12.834 13.1667V12.95C12.66 12.9834 12.4807 13 12.2967 13H3.70465C3.52065 13 3.34132 12.9827 3.16732 12.95V13.1667C3.16732 13.2993 3.11464 13.4265 3.02087 13.5203C2.9271 13.614 2.79993 13.6667 2.66732 13.6667C2.53471 13.6667 2.40753 13.614 2.31376 13.5203C2.22 13.4265 2.16732 13.2993 2.16732 13.1667V12.554C1.7587 12.2952 1.42218 11.9372 1.18906 11.5134C0.955936 11.0896 0.833791 10.6137 0.833985 10.13V8.50004C0.833985 7.66004 1.39798 6.95337 2.16798 6.73537C2.17065 6.37737 2.18132 6.11537 2.22798 5.88204C2.35017 5.26778 2.65177 4.70354 3.09463 4.26068C3.53749 3.81782 4.10172 3.51623 4.71598 3.39404C5.02265 3.33337 5.37865 3.33337 5.93732 3.33337ZM3.16865 6.73604C3.5523 6.84522 3.88989 7.0765 4.13026 7.39483C4.37063 7.71315 4.50066 8.10116 4.50065 8.50004V9.30004C4.50065 9.31871 4.51532 9.33337 4.53398 9.33337H11.4673C11.4762 9.33337 11.4846 9.32986 11.4909 9.32361C11.4971 9.31736 11.5007 9.30888 11.5007 9.30004V8.50004C11.5007 7.66137 12.064 6.95404 12.8327 6.73604C12.83 6.39604 12.8213 6.22271 12.7927 6.07737C12.7091 5.65698 12.5027 5.27081 12.1996 4.96773C11.8965 4.66465 11.5104 4.45827 11.09 4.37471C10.8927 4.33604 10.644 4.33337 10.0007 4.33337H6.00065C5.35732 4.33337 5.10865 4.33604 4.91132 4.37471C4.49092 4.45827 4.10476 4.66465 3.80168 4.96773C3.49859 5.27081 3.29222 5.65698 3.20865 6.07737C3.17998 6.22271 3.17132 6.39671 3.16865 6.73604ZM2.66732 7.66671C2.20732 7.66671 1.83398 8.04004 1.83398 8.50004V10.1294C1.83398 10.6255 2.03107 11.1013 2.38189 11.4521C2.73271 11.803 3.20852 12 3.70465 12H12.2967C12.7928 12 13.2686 11.803 13.6194 11.4521C13.9702 11.1013 14.1673 10.6255 14.1673 10.1294V8.50004C14.1673 8.27903 14.0795 8.06707 13.9232 7.91079C13.767 7.7545 13.555 7.66671 13.334 7.66671C13.113 7.66671 12.901 7.7545 12.7447 7.91079C12.5884 8.06707 12.5007 8.27903 12.5007 8.50004V9.30004C12.5007 9.5741 12.3918 9.83693 12.198 10.0307C12.0042 10.2245 11.7414 10.3334 11.4673 10.3334H4.53398C4.25993 10.3334 3.9971 10.2245 3.80331 10.0307C3.60952 9.83693 3.50065 9.5741 3.50065 9.30004V8.50004C3.50065 8.04004 3.12732 7.66671 2.66732 7.66671Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </div>
                <div v-else-if="isLetterPropertyCriteria" class="tw-order-2">RE</div>
                <h4 style="font-weight: 300 !important" :class="isLetterPropertyCriteria ? 'tw-order-1' : 'tw-order-2'">
                  {{ property.reception }}
                </h4>
              </div>
            </div>
            <div
              v-if="property.custom_property_status_title"
              class="tw-p-4"
              style="
                background-color: var(--c-primary) !important;
                color: #fff !important;
                border-radius: var(--rounded) !important;
              "
            >
              <h5 style="color: #fff !important">{{ property.custom_property_status_title }}</h5>
            </div>
            <div
              class="share-button tw-flex tw-w-2/5 tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded tw-px-7 tw-py-5 md:tw-w-3/5 lg:tw-w-auto"
              @click="onShared()"
              style="background-color: transparent; border: 1px solid var(--c-primary); color: var(--c-text_primary)"
            >
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 18.3333C14.3056 18.3333 13.7153 18.0903 13.2292 17.6042C12.7431 17.118 12.5 16.5278 12.5 15.8333C12.5 15.7361 12.5069 15.6353 12.5208 15.5308C12.5347 15.4264 12.5556 15.3328 12.5833 15.25L6.70833 11.8333C6.47222 12.0417 6.20833 12.205 5.91667 12.3233C5.625 12.4417 5.31944 12.5005 5 12.5C4.30556 12.5 3.71528 12.2569 3.22917 11.7708C2.74306 11.2847 2.5 10.6944 2.5 9.99999C2.5 9.30555 2.74306 8.71527 3.22917 8.22916C3.71528 7.74305 4.30556 7.49999 5 7.49999C5.31944 7.49999 5.625 7.55916 5.91667 7.67749C6.20833 7.79582 6.47222 7.95888 6.70833 8.16666L12.5833 4.74999C12.5556 4.66666 12.5347 4.57305 12.5208 4.46916C12.5069 4.36527 12.5 4.26443 12.5 4.16666C12.5 3.47221 12.7431 2.88193 13.2292 2.39582C13.7153 1.90971 14.3056 1.66666 15 1.66666C15.6944 1.66666 16.2847 1.90971 16.7708 2.39582C17.2569 2.88193 17.5 3.47221 17.5 4.16666C17.5 4.8611 17.2569 5.45138 16.7708 5.93749C16.2847 6.4236 15.6944 6.66666 15 6.66666C14.6806 6.66666 14.375 6.60777 14.0833 6.48999C13.7917 6.37221 13.5278 6.20888 13.2917 5.99999L7.41667 9.41666C7.44444 9.49999 7.46528 9.59388 7.47917 9.69832C7.49306 9.80277 7.5 9.90332 7.5 9.99999C7.5 10.0972 7.49306 10.198 7.47917 10.3025C7.46528 10.4069 7.44444 10.5005 7.41667 10.5833L13.2917 14C13.5278 13.7917 13.7917 13.6286 14.0833 13.5108C14.375 13.393 14.6806 13.3339 15 13.3333C15.6944 13.3333 16.2847 13.5764 16.7708 14.0625C17.2569 14.5486 17.5 15.1389 17.5 15.8333C17.5 16.5278 17.2569 17.118 16.7708 17.6042C16.2847 18.0903 15.6944 18.3333 15 18.3333Z"
                  fill="#222222"
                />
              </svg>
              <span class="tw-font-bold tw-uppercase"> Share </span>
            </div>
          </div>
        </div>
      </div>
    </library-container>
    <!-- GALLERY: START -->
    <div class="tw-mt-16 tw-grid tw-grid-cols-12 tw-gap-x-1">
      <div class="tw-relative tw-col-span-12 tw-w-full lg:tw-col-span-6" @click="onClickedImage(null)">
        <library-image
          :src="primaryFivePhotos[0].background"
          image-class="tw-rounded"
          @click="onClickedImage(primaryFivePhotos[0])"
          :blur="imageBlurFilter"
          :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
        ></library-image>
        <div v-if="isMobileDevice" class="photo-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-width="2" d="m9 6l6 6l-6 6" />
          </svg>
        </div>
        <div v-if="isMobileDevice" class="photo-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
            <path fill="none" stroke="currentColor" stroke-width="2" d="m15 6l-6 6l6 6" />
          </svg>
        </div>
        <div v-if="property.medias && property.medias.length" class="nc-first-image-overlay-item">
          <div v-if="property && property.medias" style="" class="tw-text-md tw-px-2 tw-py-1">
            1/{{ property.medias.length }}
          </div>
        </div>
      </div>
      <div v-if="!isMobileDevice" class="tw-col-span-12 tw-grid tw-grid-cols-12 tw-gap-x-1 md:tw-col-span-6">
        <div class="tw-col-span-6 tw-flex tw-flex-row tw-gap-y-1 md:tw-flex-col">
          <library-image
            :src="primaryFivePhotos[1].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[1])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>

          <library-image
            v-if="primaryFivePhotos[2]"
            :src="primaryFivePhotos[2].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[2])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
        <div class="tw-relative tw-col-span-6 tw-flex tw-flex-row tw-gap-y-1 md:tw-flex-col">
          <library-image
            v-if="primaryFivePhotos[3]"
            :src="primaryFivePhotos[3].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[3])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
          <library-image
            v-if="primaryFivePhotos[4]"
            :src="primaryFivePhotos[4].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[4])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
          <div
            v-if="primaryFivePhotos[4] && primaryFivePhotos[4].property_profile_media_id"
            class="nc-all-photos-button tw-cursor-pointer tw-uppercase"
            @click="onClickedImage(primaryFivePhotos[4])"
          >
            <library-text text="VIEW ALL PHOTOS" class="tw-text-xs tw-font-bold"></library-text>
          </div>
        </div>
      </div>
      <div v-if="isMobileDevice" class="tw-col-span-12 tw-mt-1 tw-grid tw-grid-cols-12 tw-gap-x-1">
        <div class="tw-col-span-6">
          <library-image
            v-if="primaryFivePhotos[1]"
            :src="primaryFivePhotos[1].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[1])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
        <div class="tw-col-span-6">
          <library-image
            v-if="primaryFivePhotos[2]"
            :src="primaryFivePhotos[2].background"
            image-class="tw-rounded"
            @click="onClickedImage(primaryFivePhotos[2])"
            :blur="imageBlurFilter"
            :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
          ></library-image>
        </div>
      </div>
    </div>
    <!-- GALLERY: END -->
    <library-container v-if="!property.is_locked" class="tw-mt-20">
      <div class="tw-grid tw-grid-cols-12 md:tw-gap-x-10">
        <div class="property-actions tw-col-span-12 tw-flex tw-flex-col tw-gap-y-12 lg:tw-col-span-8">
          <!-- Property Video, Send Lead: START -->
          <property-detail-actions
            v-if="isMobileDevice"
            :property="property"
            :component="component"
            class="tw-col-span-12"
            @on-send-lead="onSendLead()"
          />
          <!-- Property Video, Send Lead: END -->

          <!-- FEATURES: START -->
          <div v-if="!property.is_locked" class="tw-flex tw-flex-col">
            <h4>FEATURES</h4>
            <div class="tw-mt-4 tw-grid tw-grid-cols-12 tw-gap-x-3" ref="featuresGrid">
              <div
                v-for="(feature, index) in property.features"
                :key="`property-feature-${index}`"
                class="tw-col-span-12 tw-flex md:tw-col-span-6"
                :class="featuresBoxStyle === 1 ? 'tw-items-center' : ''"
                :style="[featuresBoxStyle === 2 ? `border-bottom: 1px solid var(--default-border-color)` : '']"
                style="padding-top: 15px; padding-bottom: 15px; height: auto"
              >
                <span v-if="featuresBoxStyle === 1" class="tw-pr-2">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.5501 18L3.8501 12.3L5.2751 10.875L9.5501 15.15L18.7251 5.97498L20.1501 7.39998L9.5501 18Z"
                      fill="var(--c-secondary)"
                    />
                  </svg>
                </span>
                <library-text class="tw-uppercase" :text="feature"> </library-text>
              </div>
            </div>
          </div>
          <!-- FEATURES: END -->
          <div v-if="!property.is_locked">
            <h3>PROPERTY INFORMATION</h3>
            <ul class="nav nav-tabs pxp-nav-tabs tw-mt-6">
              <li v-for="(tab, tabIndex) in tabs" :key="`tab-${tabIndex}`" class="nav-item">
                <div
                  :class="activeTab === tab.name ? 'active' : ''"
                  class="nav-link tw-cursor-pointer"
                  data-toggle="tab"
                  @click="activeTab = tab.name"
                >
                  {{ tab.title }}
                </div>
              </li>
            </ul>
            <div class="tab-content tw-mt-6">
              <div v-show="activeTab === 'description'" id="description" role="tabpanel">
                <div>
                  <div v-if="property.description">
                    <library-text style="font-weight: 300 !important" :html="property.description"></library-text>
                  </div>
                  <div
                    class="tw-mt-4 tw-flex tw-flex-col tw-gap-4 md:tw-mt-8 md:tw-flex-row md:tw-flex-wrap md:tw-gap-6"
                  >
                    <div
                      v-for="criteria in property.criteria_list"
                      :key="criteria.id"
                      class="tw-flex tw-gap-4 tw-p-4"
                      style="background-color: var(--c-section_primary); border-radius: var(--rounded)"
                    >
                      <span v-if="criteria.title === 'Parking'">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M45 21.5955H42.7312L37.4231 9.65358C37.2168 9.18982 36.8805 8.79581 36.4549 8.51927C36.0293 8.24273 35.5326 8.09552 35.025 8.09546H12.975C12.4674 8.09552 11.9707 8.24273 11.5451 8.51927C11.1195 8.79581 10.7832 9.18982 10.5769 9.65358L5.26875 21.5955H3C2.70163 21.5955 2.41548 21.714 2.2045 21.925C1.99353 22.1359 1.875 22.4221 1.875 22.7205C1.875 23.0188 1.99353 23.305 2.2045 23.516C2.41548 23.7269 2.70163 23.8455 3 23.8455H4.875V39.2205C4.875 39.9167 5.15156 40.5843 5.64384 41.0766C6.13613 41.5689 6.80381 41.8455 7.5 41.8455H12C12.6962 41.8455 13.3639 41.5689 13.8562 41.0766C14.3484 40.5843 14.625 39.9167 14.625 39.2205V35.8455H33.375V39.2205C33.375 39.9167 33.6516 40.5843 34.1438 41.0766C34.6361 41.5689 35.3038 41.8455 36 41.8455H40.5C41.1962 41.8455 41.8639 41.5689 42.3562 41.0766C42.8484 40.5843 43.125 39.9167 43.125 39.2205V23.8455H45C45.2984 23.8455 45.5845 23.7269 45.7955 23.516C46.0065 23.305 46.125 23.0188 46.125 22.7205C46.125 22.4221 46.0065 22.1359 45.7955 21.925C45.5845 21.714 45.2984 21.5955 45 21.5955ZM12.6319 10.5686C12.6613 10.5021 12.7094 10.4457 12.7703 10.4061C12.8312 10.3665 12.9023 10.3454 12.975 10.3455H35.025C35.0977 10.3454 35.1688 10.3665 35.2297 10.4061C35.2906 10.4457 35.3387 10.5021 35.3681 10.5686L40.2694 21.5955H7.73063L12.6319 10.5686ZM12.375 39.2205C12.375 39.3199 12.3355 39.4153 12.2652 39.4856C12.1948 39.556 12.0995 39.5955 12 39.5955H7.5C7.40054 39.5955 7.30516 39.556 7.23483 39.4856C7.16451 39.4153 7.125 39.3199 7.125 39.2205V35.8455H12.375V39.2205ZM40.5 39.5955H36C35.9005 39.5955 35.8052 39.556 35.7348 39.4856C35.6645 39.4153 35.625 39.3199 35.625 39.2205V35.8455H40.875V39.2205C40.875 39.3199 40.8355 39.4153 40.7652 39.4856C40.6948 39.556 40.5995 39.5955 40.5 39.5955ZM40.875 33.5955H7.125V23.8455H40.875V33.5955ZM10.875 28.7205C10.875 28.4221 10.9935 28.1359 11.2045 27.925C11.4155 27.714 11.7016 27.5955 12 27.5955H15C15.2984 27.5955 15.5845 27.714 15.7955 27.925C16.0065 28.1359 16.125 28.4221 16.125 28.7205C16.125 29.0188 16.0065 29.305 15.7955 29.516C15.5845 29.7269 15.2984 29.8455 15 29.8455H12C11.7016 29.8455 11.4155 29.7269 11.2045 29.516C10.9935 29.305 10.875 29.0188 10.875 28.7205ZM31.875 28.7205C31.875 28.4221 31.9935 28.1359 32.2045 27.925C32.4155 27.714 32.7016 27.5955 33 27.5955H36C36.2984 27.5955 36.5845 27.714 36.7955 27.925C37.0065 28.1359 37.125 28.4221 37.125 28.7205C37.125 29.0188 37.0065 29.305 36.7955 29.516C36.5845 29.7269 36.2984 29.8455 36 29.8455H33C32.7016 29.8455 32.4155 29.7269 32.2045 29.516C31.9935 29.305 31.875 29.0188 31.875 28.7205Z"
                            fill="var(--c-secondary)"
                          />
                        </svg>
                      </span>

                      <span v-else-if="criteria.title === 'Sewerage'">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M43.5 20.0955H38.625V10.3455H43.5C43.7984 10.3455 44.0845 10.2269 44.2955 10.016C44.5065 9.80498 44.625 9.51883 44.625 9.22046C44.625 8.92209 44.5065 8.63594 44.2955 8.42496C44.0845 8.21399 43.7984 8.09546 43.5 8.09546H38.3681C38.1555 7.6472 37.8202 7.26837 37.4011 7.00289C36.9819 6.7374 36.4961 6.59614 36 6.59546H33C32.5039 6.59614 32.0181 6.7374 31.5989 7.00289C31.1798 7.26837 30.8445 7.6472 30.6319 8.09546H27C21.9296 8.10141 17.0685 10.1183 13.4832 13.7036C9.89782 17.289 7.88095 22.15 7.875 27.2205V30.8523C7.42674 31.065 7.04791 31.4003 6.78243 31.8194C6.51694 32.2385 6.37568 32.7243 6.375 33.2205V36.2205C6.37568 36.7166 6.51694 37.2024 6.78243 37.6215C7.04791 38.0406 7.42674 38.376 7.875 38.5886V43.7205C7.875 44.0188 7.99353 44.305 8.2045 44.516C8.41548 44.7269 8.70163 44.8455 9 44.8455C9.29837 44.8455 9.58452 44.7269 9.7955 44.516C10.0065 44.305 10.125 44.0188 10.125 43.7205V38.8455H19.875V43.7205C19.875 44.0188 19.9935 44.305 20.2045 44.516C20.4155 44.7269 20.7016 44.8455 21 44.8455C21.2984 44.8455 21.5845 44.7269 21.7955 44.516C22.0065 44.305 22.125 44.0188 22.125 43.7205V38.5886C22.5733 38.376 22.9521 38.0406 23.2176 37.6215C23.4831 37.2024 23.6243 36.7166 23.625 36.2205V33.2205C23.6243 32.7243 23.4831 32.2385 23.2176 31.8194C22.9521 31.4003 22.5733 31.065 22.125 30.8523V27.2205C22.125 25.9275 22.6386 24.6876 23.5529 23.7733C24.4671 22.8591 25.7071 22.3455 27 22.3455H30.6319C30.8445 22.7937 31.1798 23.1726 31.5989 23.438C32.0181 23.7035 32.5039 23.8448 33 23.8455H36C36.4961 23.8448 36.9819 23.7035 37.4011 23.438C37.8202 23.1726 38.1555 22.7937 38.3681 22.3455H43.5C43.7984 22.3455 44.0845 22.2269 44.2955 22.016C44.5065 21.805 44.625 21.5188 44.625 21.2205C44.625 20.9221 44.5065 20.6359 44.2955 20.425C44.0845 20.214 43.7984 20.0955 43.5 20.0955ZM21 32.8455C21.0995 32.8455 21.1948 32.885 21.2652 32.9553C21.3355 33.0256 21.375 33.121 21.375 33.2205V36.2205C21.375 36.3199 21.3355 36.4153 21.2652 36.4856C21.1948 36.556 21.0995 36.5955 21 36.5955H9C8.90054 36.5955 8.80516 36.556 8.73483 36.4856C8.66451 36.4153 8.625 36.3199 8.625 36.2205V33.2205C8.625 33.121 8.66451 33.0256 8.73483 32.9553C8.80516 32.885 8.90054 32.8455 9 32.8455H21ZM19.875 27.2205V30.5955H10.125V27.2205C10.13 22.7465 11.9095 18.4571 15.0731 15.2935C18.2367 12.1299 22.526 10.3504 27 10.3455H30.375V20.0955H27C25.1103 20.0955 23.2981 20.8461 21.9619 22.1823C20.6257 23.5185 19.875 25.3308 19.875 27.2205ZM36 21.5955H33C32.9005 21.5955 32.8052 21.556 32.7348 21.4856C32.6645 21.4153 32.625 21.3199 32.625 21.2205V9.22046C32.625 9.121 32.6645 9.02562 32.7348 8.95529C32.8052 8.88497 32.9005 8.84546 33 8.84546H36C36.0995 8.84546 36.1948 8.88497 36.2652 8.95529C36.3355 9.02562 36.375 9.121 36.375 9.22046V21.2205C36.375 21.3199 36.3355 21.4153 36.2652 21.4856C36.1948 21.556 36.0995 21.5955 36 21.5955Z"
                            fill="var(--c-secondary)"
                          />
                        </svg>
                      </span>

                      <span v-else-if="criteria.title === 'Water'">
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5 34.6805V32.6045C6.036 32.4765 6.84267 32.1365 7.42 31.5845C7.99867 31.0338 9.092 30.7585 10.7 30.7585C12.3853 30.7585 13.5747 31.0918 14.268 31.7585C14.9613 32.4251 15.9847 32.7585 17.338 32.7585C18.7073 32.7585 19.7387 32.4251 20.432 31.7585C21.1253 31.0918 22.3147 30.7585 24 30.7585C25.6693 30.7585 26.8587 31.0918 27.568 31.7585C28.2773 32.4251 29.3087 32.7585 30.662 32.7585C32.0313 32.7585 33.0587 32.4251 33.744 31.7585C34.4307 31.0918 35.616 30.7585 37.3 30.7585C38.908 30.7585 40.0013 31.0345 40.58 31.5865C41.1573 32.1371 41.964 32.4771 43 32.6065V34.6825C41.792 34.5278 40.8333 34.1685 40.124 33.6045C39.4147 33.0405 38.4733 32.7585 37.3 32.7585C35.972 32.7585 34.9547 33.0918 34.248 33.7585C33.5413 34.4251 32.346 34.7585 30.662 34.7585C28.9927 34.7585 27.8033 34.4251 27.094 33.7585C26.3847 33.0918 25.3533 32.7591 24 32.7605C22.6307 32.7605 21.5993 33.0938 20.906 33.7605C20.2127 34.4271 19.0233 34.7605 17.338 34.7605C15.6527 34.7605 14.4613 34.4271 13.764 33.7605C13.0667 33.0938 12.0453 32.7605 10.7 32.7605C9.484 32.7605 8.54867 33.0425 7.894 33.6065C7.23933 34.1718 6.27467 34.5311 5 34.6845M5 27.1445V25.0685C6.036 24.9405 6.84267 24.6005 7.42 24.0485C7.99867 23.4978 9.092 23.2225 10.7 23.2225C12.3693 23.2225 13.5547 23.5558 14.256 24.2225C14.9573 24.8891 15.9847 25.2225 17.338 25.2225C18.7073 25.2225 19.7387 24.8891 20.432 24.2225C21.1253 23.5558 22.3147 23.2218 24 23.2205C25.6693 23.2205 26.856 23.5538 27.56 24.2205C28.264 24.8871 29.2907 25.2205 30.64 25.2205C32.008 25.2205 33.0387 24.8871 33.732 24.2205C34.4253 23.5538 35.6147 23.2205 37.3 23.2205C38.892 23.2205 39.9853 23.4965 40.58 24.0485C41.1733 24.5991 41.98 24.9385 43 25.0665V27.1425C41.7773 26.9891 40.8153 26.6305 40.114 26.0665C39.4127 25.5025 38.4747 25.2205 37.3 25.2205C35.972 25.2205 34.9547 25.5538 34.248 26.2205C33.5413 26.8871 32.346 27.2205 30.662 27.2205C28.9927 27.2205 27.8033 26.8871 27.094 26.2205C26.386 25.5538 25.3547 25.2205 24 25.2205C22.6307 25.2205 21.6033 25.5538 20.918 26.2205C20.2313 26.8871 19.046 27.2205 17.362 27.2205C15.678 27.2205 14.478 26.8871 13.762 26.2205C13.046 25.5538 12.0253 25.2205 10.7 25.2205C9.5 25.2205 8.56467 25.5025 7.894 26.0665C7.22333 26.6305 6.25867 26.9898 5 27.1445ZM5 19.6045V17.5285C6.036 17.4005 6.84267 17.0605 7.42 16.5085C7.99867 15.9578 9.092 15.6825 10.7 15.6825C12.3693 15.6825 13.5547 16.0158 14.256 16.6825C14.9573 17.3491 15.9847 17.6825 17.338 17.6825C18.7073 17.6825 19.7387 17.3491 20.432 16.6825C21.1253 16.0158 22.3147 15.6818 24 15.6805C25.6693 15.6805 26.856 16.0138 27.56 16.6805C28.264 17.3471 29.2907 17.6805 30.64 17.6805C32.008 17.6805 33.0387 17.3471 33.732 16.6805C34.4253 16.0138 35.6147 15.6805 37.3 15.6805C38.892 15.6805 39.9853 15.9558 40.58 16.5065C41.1733 17.0585 41.98 17.3985 43 17.5265V19.6025C41.7773 19.4491 40.8153 19.0905 40.114 18.5265C39.4127 17.9625 38.4747 17.6805 37.3 17.6805C35.972 17.6805 34.9547 18.0138 34.248 18.6805C33.5413 19.3471 32.346 19.6805 30.662 19.6805C28.9927 19.6805 27.8033 19.3471 27.094 18.6805C26.386 18.0138 25.3547 17.6805 24 17.6805C22.6307 17.6805 21.6033 18.0138 20.918 18.6805C20.2313 19.3471 19.046 19.6805 17.362 19.6805C15.678 19.6805 14.478 19.3471 13.762 18.6805C13.046 18.0138 12.0253 17.6805 10.7 17.6805C9.5 17.6805 8.552 17.9625 7.856 18.5265C7.16 19.0905 6.208 19.4498 5 19.6045Z"
                            fill="var(--c-secondary)"
                          />
                        </svg>
                      </span>
                      <span v-else>
                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_481_37820)">
                            <path
                              d="M44.9467 23.2738L24.9467 3.27383C24.6969 3.0255 24.359 2.88611 24.0067 2.88611C23.6545 2.88611 23.3165 3.0255 23.0667 3.27383L3.0667 23.2738C2.84827 23.5289 2.73413 23.857 2.74709 24.1926C2.76005 24.5281 2.89916 24.8465 3.13662 25.0839C3.37408 25.3214 3.6924 25.4605 4.02797 25.4734C4.36353 25.4864 4.69163 25.3723 4.9467 25.1538L24 6.1005L43.0534 25.1672C43.3084 25.3856 43.6365 25.4997 43.9721 25.4868C44.3077 25.4738 44.626 25.3347 44.8635 25.0972C45.1009 24.8598 45.24 24.5415 45.253 24.2059C45.2659 23.8703 45.1518 23.5422 44.9334 23.2872L44.9467 23.2738Z"
                              fill="var(--c-secondary)"
                            />
                            <path
                              d="M37.3333 42.8872H30.6667V29.5538H17.3333V42.8872H10.6667V24.2205L8 26.8872V42.8872C8 43.5944 8.28095 44.2727 8.78105 44.7728C9.28115 45.2729 9.95942 45.5538 10.6667 45.5538H20V32.2205H28V45.5538H37.3333C38.0406 45.5538 38.7189 45.2729 39.219 44.7728C39.7191 44.2727 40 43.5944 40 42.8872V26.5672L37.3333 23.9005V42.8872Z"
                              fill="var(--c-secondary)"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_481_37820">
                              <rect width="48" height="48" fill="white" transform="translate(0 0.220459)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <div>
                        <small class="n-title-primary tw-uppercase">{{ criteria.title }}</small>
                        <p>{{ criteria.value }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="activeTab === 'video'" id="video" role="tabpanel">
                <div v-if="property?.featured_video">
                  <div class="tw-aspect-[16/9] tw-h-full tw-w-full">
                    <library-iframe
                      class="tw-absolute tw-inset-0 tw-h-full tw-w-full"
                      :src="property.featured_video.mediaLink"
                      frameborder="0"
                      allowfullscreen
                      :blur="imageBlurFilter"
                      :pre-market-blur-text="preMarketBlurText"
                    ></library-iframe>
                  </div>
                </div>
              </div>
              <div v-show="activeTab === 'floor_plan'" id="floor_plan" role="tabpanel">
                <floor-plan :data="property.floor_plans" :component="component" />
              </div>
              <div v-show="activeTab === 'map'" id="map" role="tabpanel">
                <neuron-google-map
                  v-if="property.map_position && property.map_position.lat && property.map_position.lng"
                  v-model:map-center-position="property.map_position"
                  :component="component"
                  :marker-color="markerColorV2"
                />
              </div>
              <div v-show="activeTab === 'epc'" id="epc" role="tabpanel">
                <epc :data="property.epcs" :component="component" />
              </div>
            </div>
          </div>

          <library-tools-stamp-duty-calculator
            v-if="isMortgageCalculatorVisible && !property.is_locked"
            :default-price="property.price.numberPrice"
          />
          <library-tools-mortgage-calculator
            v-if="isStampDutyCalculatorVisible && !property.is_locked"
            :default-price="property.price.numberPrice"
          />
        </div>
        <!-- Property Video, Send Lead: START -->
        <div class="detail-sidebar tw-col-span-12 lg:tw-col-span-4">
          <property-detail-actions
            v-if="!isMobileDevice"
            :property="property"
            :component="component"
            @on-send-lead="onSendLead()"
          />
          <div v-if="sidebarComponents && sidebarComponents.length" class="tw-mt-4">
            <available-components-for-sidebar
              key="property-detail-sidebar"
              key-prefix="property-detail-sidebar"
              :specific-components="sidebarComponents"
            />
          </div>
        </div>
        <!-- Property Video, Send Lead: END -->
      </div>
    </library-container>

    <library-container v-else-if="property.is_locked">
      <div class="tw-mt-10">
        <library-login />
      </div>
    </library-container>

    <full-screen-gallery
      v-if="fullScreenPopupConfig.is_active && activeMedia && property && property.medias && !property.is_locked"
      v-model:active-media-index="activeMediaIndex"
      :component="component"
      :active-media="activeMedia"
      :count-of-medias="property.medias.length"
      @close="closeLightbox()"
    />

    <popup v-if="!property.is_locked" :config="sendLeadPopupConfig" custom-width="800px">
      <template #content>
        <send-lead
          v-if="sendLeadPopupConfig.isActive"
          :property="property"
          @on-success="onSuccess"
          @close="sendLeadPopupConfig.isActive = false"
        />
      </template>
    </popup>
    <popup v-if="!property.is_locked" :config="successModalConfig" @close="onSuccessModalClosed()">
      <template #content>
        <success :text="successPopupText" />
      </template>
    </popup>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia';
import { ROUTES } from '~/constants/ui.constants';
import { usePropertiesStore } from '~/units/properties/stores';
import type { Component } from '~/types';
import { ComponentMixin } from '~/mixins/component.mixin';
import { PropertyMixin } from '~/units/properties/mixins/property.mixin';
import FloorPlan from '~/components/common/FloorPlan.vue';
import NeuronGoogleMap from '~/components/common/NeuronGoogleMap.vue';
import Epc from '~/components/common/Epc.vue';
import NcSelect from '~/components/common/inputs/NcSelect.vue';
import NcInput from '~/components/common/inputs/NcInput.vue';
import NcButton from '~/components/common/inputs/NcButton.vue';
import FullScreenGallery from '~/components/common/FullScreenGallery.vue';
import { useCoreStore } from '~/units/core/store';
import SendLead from '~/components/common/leads/SendLead.vue';
import Success from '~/components/common/popup/Success.vue';
import Popup from '~/components/common/popup/Popup.vue';
import PropertyDetailActions from '~/components/theme3/properties/PropertyDetailActions.vue';
import AvailableComponentsForSidebar from '~/components/theme3/AvailableComponentsForSidebar.vue';
import { getImagesByCount } from '~/units/properties/store';

export default defineNuxtComponent({
  name: 'Theme3PropertyDetail',
  components: {
    AvailableComponentsForSidebar,
    PropertyDetailActions,
    Popup,
    Success,
    SendLead,
    FullScreenGallery,
    NcButton,
    NcInput,
    NcSelect,
    Epc,
    NeuronGoogleMap,
    FloorPlan,
  },

  mixins: [ComponentMixin, PropertyMixin],

  data() {
    return {
      activeTab: 'description',
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  computed: {
    tabs() {
      const tabs = [
        {
          name: 'description',
          title: 'Description',
          is_visible: true,
        },
        {
          name: 'information',
          title: 'Information',
          is_visible: this.company.company_key !== 'jacksonsproperty',
        },
        {
          name: 'video',
          title: 'Video',
          is_visible: !!this.property?.featured_video,
        },
        {
          name: 'floor_plan',
          title: 'Floor Plan',
          is_visible: !!this.property?.floor_plans?.length,
        },
        {
          name: 'map',
          title: 'Map',
          is_visible: true,
        },
        {
          name: 'epc',
          title: 'EPC',
          is_visible: !!this.property?.epcs?.length,
        },
      ];

      return tabs.filter((i) => i.is_visible);
    },

    imageBlurFilter() {
      if (this.property?.is_locked) {
        return '12px';
      }
      return undefined;
    },

    featuresBoxStyle() {
      if (this.vars.featuresStyleNumber) {
        return this.vars.featuresStyleNumber;
      }
      return 1; // b;
    },

    markerColor() {
      return this.colors.purple;
    },

    markerColorV2() {
      return this.colors.primary;
    },

    ROUTES() {
      return ROUTES;
    },

    primaryFivePhotos() {
      if (this.property) {
        return getImagesByCount(this.property, 5);
      }
      return [];
    },

    sidebarComponents(): Component[] {
      if (this.currentPage && this.currentPage.sidebar) {
        return this.currentPage.sidebar;
      }
      return [];
    },

    isMortgageCalculatorVisible() {
      return !this.vars.isMortgageCalculatorHiddenNumber;
    },

    isStampDutyCalculatorVisible() {
      return !this.vars.isStampDutyCalculatorHiddenNumber;
    },

    isLetterPropertyCriteria() {
      return this.vars.isLetterPropertyCriteriaNumber;
    },
  },

  methods: {
    ...mapActions(useCoreStore, ['shareApi', 'openTab']),

    async onShared() {
      await this.shareApi({
        title: this.property?.advert_heading,
        text: this.property?.advert_heading,
        url: window.location.href,
      });
    },
  },

  async setup(props: { component: Component }) {
    const store = usePropertiesStore();
    await store.fetchSingleProperty(props.component);
  },
});
</script>

<style scoped>
.share-button {
  border: 2px solid var(--camel);
}

.nav-link.active {
  color: var(--purple);
  border-bottom-color: var(--purple);
}

.nav-link {
  color: var(--black);
  font-size: 16px;
}

.nc-first-image-overlay-item {
  position: absolute;
  bottom: 0.1rem;
  right: 0.1rem;
  transform: translate(-50%, -50%);
  text-align: right;
  background-color: var(--white);
  color: var(--nc-classic-black);
  border-radius: 4px;
}

.nc-all-photos-button {
  position: absolute;
  bottom: 20px;
  left: 70px;
  padding: 10px;
  border-radius: 4px;
  background-color: var(--white);
  color: var(--nc-classic-black);
}

.photo-next,
.photo-prev {
  position: absolute;
  top: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  cursor: pointer;
  font-size: 26px;
}

.photo-next {
  right: 5%;
}

.photo-prev {
  left: 5%;
}
</style>
